export default __webpack_public_path__ + "static/media/master-bg.20778343.webp";